import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, NgZone, SecurityContext } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';

import { AlertService } from '../../core/alert/alert.service';


import { UploadFileService } from './upload-file.service';
import { API } from '../constants';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { ok } from 'assert';

@Component({
  selector: 'cms-form-media',
  templateUrl: './form-media.component.html',
  styleUrls: [
    './form-media.component.scss'
  ]
})
export class FormMediaComponent implements OnInit, OnDestroy {


  @Input() entity: any;
  @Input() categoryID: any;
  @Input() ItemID: any;
  @Input() photoCategory: any;
  @Input() maxmedia: number = 10;
  @Input() label: string;
  @Input() medias: Array<any> = [];
  @Input() isDisabled: boolean = false;
  @Input() forumImage: boolean = false

  @Output() droppedMedia = new EventEmitter<any>();
  @Output() addedMedia = new EventEmitter<any>();
  @Output() updatedMedia = new EventEmitter<any[]>();
  @Output() addedText = new EventEmitter<any>();
  @Output() chooseColor = new EventEmitter<any>();
  @Output() forumFakePath = new EventEmitter<any>()

  Image = {};
  mediaUrl = `${API.ENDPOINT.MEDIA.GET}`;
  isUploading: boolean;
  isDropped: boolean;
  progress: number = 0;
  isThumb: boolean = false;
  private sub: any;
  selectedColor: string;

  // To be translated

  thumbnailMessage;
  thumbnailTitle;
  thumbnailOkText;
  thumbnailCancel;
  errorInvalidMessage;
  errorMessage;
  errorTitle;
  errorOkText;
  errorCancel;
  InvalidFileTypeMessage;
  InvalidFileTypeTitle;
  InvalidFileTypeOkText;
  InvalidFileTypeCancel;
  maxSizeMessage;
  maxSizeTitle;
  maxSizeokText;
  maxSizeCancel;
  deleteMessage;
  deleteTitle;
  deleteOkButton;
  deleteCancel;

  constructor(
    private zone: NgZone,
    private DomSanitizer: DomSanitizer,
    private alertService: AlertService,
    private uploadFileService: UploadFileService,
    private http: Http,
    private translator: TranslateService,
  ) { }

  ngOnInit() {
    this.populateYoutubeThumbnail();
    this.translateMessages();

    if (this.entity.type === 'vehicle_main_photo' ||
      this.entity.type === 'loginImage' ||
      this.entity.type === 'file' ||
      this.entity.type === 'pdf_folder' ||
      this.entity.type === 'colors' ||
      this.entity.type === 'vehicle_news' ||
      this.entity.type === 'acessoryMainPhoto' ||
      this.entity.type === 'pushAttachmentMedia' ||
      this.entity.type === 'pushNewsMedia' ||
      this.entity.type === 'photoMobile' ||
      this.entity.type === 'photoTabletVertical' ||
      this.entity.type === 'photoTabletHorizontal' ||
      this.entity.type === 'pushVideoMedia') {
      this.maxmedia = 1;
    }

    this.sub = this.uploadFileService
      .progress$
      .subscribe((data) => {
        this.zone.run(() => {
          this.progress = data;
        });
      });
  }

  translateMessages() {
    this.translator.get('modal').subscribe((res) => {

      this.thumbnailMessage = res.alert['media-thumbnail-message'];
      this.thumbnailTitle = res.alert['confirm-message'];
      this.thumbnailOkText = res.alert['confirm-ok'];
      this.thumbnailCancel = res.alert['cancel'];
      this.errorInvalidMessage = res.alert['media-invalid-message'];
      this.errorMessage = res.alert['media-error-message'];
      this.errorTitle = res.alert['media-error-title'];
      this.errorOkText = res.alert['media-error-ok'];
      this.errorCancel = res.alert['cancel'];
      this.InvalidFileTypeMessage = res.alert['media-invalidfiletype-message'];
      this.InvalidFileTypeTitle = res.alert['media-invalidfiletype-title'];
      this.InvalidFileTypeOkText = res.alert['media-invalidfiletype-ok'];
      this.InvalidFileTypeCancel = res.alert['cancel'];
      this.maxSizeMessage = res.alert['media-maxsize-message'];
      this.maxSizeTitle = res.alert['media-maxsize-title'];
      this.maxSizeokText = res.alert['media-maxsize-ok'];
      this.maxSizeCancel = res.alert['cancel'];
      this.deleteMessage = res.alert['media-delete-message'];
      this.deleteTitle = res.alert['media-delete-title'];
      this.deleteOkButton = res.alert['media-delete-ok'];
      this.deleteCancel = res.alert['cancel'];
    });
  }
  populateYoutubeThumbnail(): any {
    const mediasWithYoutube = this.medias.filter((res) => {
      return res.youtubeVideoLink;
    });
    mediasWithYoutube.forEach((res) => {
      this.getThumbnail(res.youtubeVideoLink, res.fileName, 'youtubeVideoLink');
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onMediaLoaded(medias) {
    this.medias = medias;
  }

  onChange(pictureText, fileName, textType) {
    if (textType === 'youtubeVideoLink') {
      this.getThumbnail(pictureText, fileName, textType)
    }
    this.addedText.emit({ pictureText, fileName, textType });
  }

  getThumbnail(pictureText, fileName, textType) {
    if (pictureText.indexOf('playlist') > -1) {
      const id = pictureText.split('=')[1].split('&')[0];
      this.getImageFromList(id).toPromise().then((res) => {
        this.Image[fileName] = res;
      });
    }
    else {
      if (pictureText.indexOf('=') > -1) {
        const id = pictureText.split('=')[1].split('&')[0];
        this.Image[fileName] = `https://img.youtube.com/vi/${id}/0.jpg`;
      } else {
        const id = pictureText.split('=')[1];
        this.Image[fileName] = `https://img.youtube.com/vi/${id}/0.jpg`;
      }
    }
  }

  getImageFromList(id) {
    return this.http.get(`https://www.googleapis.com/youtube/v3/playlists?part=snippet&id=
                          ${id}
                          &key=AIzaSyBI7ChS0pOFdWY0meF-2W46a1PU3Ju0Ung`)
      .map((res) => {
        let imgUrl = res.json().items[0].snippet.thumbnails.high.url;
        return imgUrl;
      });
  }

  //when user choose color
  onChangeColor(colorId, media) {
    this.chooseColor.emit({ colorId, media })
  }

  dropped(event) {
    this.droppedMedia.emit(this.medias);
  }

  // Add files functionality:
  addFile(file: File, mediaName: string): void {


    if (this.isInvalidMedia(file)) {
      this.sendInvalidAlert();
      return;
    }

    this.progress = 0;
    this.isUploading = true;
    this.addedMedia.emit('started');

    let _that = this;

    let mediaToAdd = {
      _id: '',
      fileName: '',
      contentType: '',
      isNew: true,
    };

    if (!this.isThumb) {
      _that.medias.push(mediaToAdd);
    }
    const order = this.medias.length - 1;

    let fileToSend: any;


    const TimeStamp = new Date().getTime()
    if (mediaName) {
      fileToSend = {
        entityId: _that.entity.id,
        entityType: _that.entity.type,
        media: {
          contentType: file.type,
          videoName: mediaName
        }
      };
    } else {
      if (_that.entity.type === 'version_image') {
        fileToSend = {
          entityId: _that.entity.id,
          entityType: _that.entity.type,
          versionId: _that.entity.versionId,
          media: {
            contentType: file.type,
            fileName: TimeStamp + '_' + file.name.split(" ").join("_"),
            order: order,
            colorId: '123'
          }
        };
      } else {
        fileToSend = {
          entityId: _that.entity.id,
          entityType: _that.entity.type,
          media: {
            contentType: file.type,
            fileName: TimeStamp + '_' + file.name.split(" ").join("_"),
            order: order
          }
        };
      }
    }

    if (this.categoryID) {
      fileToSend.media.category = this.categoryID;
    };

    var reader = new FileReader();
    let isThumb = this.isThumb

    reader.onloadend = function (isThumb) {

      _that.uploadFileService
        .makeFileRequest(file, fileToSend, mediaName ? true : false)
        .subscribe((response) => {

          if (mediaName) {
            _that.isThumb = false;


            mediaToAdd = {
              _id: response.media._id,
              fileName: response.media.fileName.split(" ").join("_"),
              contentType: fileToSend.media.contentType,
              isNew: true
            };
            _that.medias[order + 1] = mediaToAdd;
          } else {
            let isNew = false;
            if (fileToSend.media.contentType.indexOf('video') !== -1) {
              isNew = true;
            }

            mediaToAdd = {
              _id: response.media._id,
              fileName: response.media.fileName.split(" ").join("_"),
              contentType: fileToSend.media.contentType,
              isNew: isNew
            };

            if (_that.categoryID) {
              mediaToAdd['category'] = _that.categoryID;
            };

            _that.medias[order] = mediaToAdd;
            if (_that.categoryID) {
              _that.addedMedia.emit({ type: "category", media: mediaToAdd });
            }

          }

        },
          (error) => {

            let message = _that.errorMessage;
            let title = _that.errorTitle;
            let okText = _that.errorOkText;
            let cancelText = _that.errorCancel;



            _that.alertService
              .activate(message, title, okText, cancelText)
              .then((response) => {
                _that.isUploading = false;
              });
          },
          () => {
            if (fileToSend.media.contentType.indexOf('video') !== -1) {
              _that.isUploading = false;
            } else {
              _that.updatedMedia.emit(_that.medias);
              _that.isUploading = false;
            }
          });

    }

    reader.readAsDataURL(file);
  }

  sendInvalidAlert() {
    if (this.entity.type == 'pushAttachmentMedia' || this.entity.type === 'pdf_diagram' || this.entity.type === 'pdf_folder') {
      let message = this.InvalidFileTypeMessage;
      let title = this.InvalidFileTypeTitle;
      let okText = this.InvalidFileTypeOkText;
      let cancelText = this.InvalidFileTypeCancel;



      this.alertService
        .activate(message, title, okText, cancelText)
        .then((response) => { });
    }
    else {
      let message = this.maxSizeMessage;
      let title = this.maxSizeTitle;
      let okText = this.maxSizeokText;
      let cancelText = this.maxSizeCancel;

      this.alertService
        .activate(message, title, okText, cancelText)
        .then((response) => { });
    }
  }

  // Remove files functionality:
  deleteFile(media: any): void {

    if(!this.forumImage) {

      let message = this.deleteMessage;
      let title = this.deleteTitle;
      let okText = this.deleteOkButton;
      let cancelText = this.deleteCancel;

      this.alertService
        .activate(message, title, okText, cancelText)
        .then((response) => {
          if (response) {
            let mediaToDelete = {};
            if (this.entity.type === 'version_image') {
              mediaToDelete = {
                fileName: media.fileName,
                entityId: this.entity.id,
                entityType: this.entity.type,
                versionId: this.entity.versionId
              };
            } else {
              mediaToDelete = {
                fileName: media.fileName,
                entityId: this.entity.id,
                entityType: this.entity.type
              };
            }

            this
              .uploadFileService
              .deleteMedia(mediaToDelete)
              .then((result) => {
                this.medias.forEach((mediaCurrent, index) => {
                  if (mediaCurrent.fileName === media.fileName) {
                    this.medias.splice(index, 1);
                    this.updatedMedia.emit(this.medias);
                  }
                });
              });
          }
        });

    } else {

      this.medias = []

    }

  }

  allowDrop(ev: any): void {
    ev.preventDefault();
  }

  uploadImageForum(event) {

    console.log(event.target.files)
    this.forumFakePath.emit(event.target.files)

    this.medias = [
      {
        _id: '',
        fileName: '',
        contentType: '',
        isNew: true,
      }
    ]

  }

  inputFile(event: any): void {

    if (event.target.files &&
      event.target.files[0]) {
      let fileList = event.target.files;

      this.addFile(fileList[0], null);
      event.target.value = '';
    }

  }

  dropFile(event: any): void {

    event.preventDefault();

    if (event.dataTransfer.files &&
      event.dataTransfer.files[0]) {
      let fileList = event.dataTransfer.files;

      this.addFile(fileList[0], null);
      event.target.value = '';
    }
  }

  inputThumbnailFile(event: any, mediaName: any): void {

    if (event.target.files &&
      event.target.files[0]) {
      let fileList = event.target.files;

      // check if input file is really an image file
      if (fileList[0].type.indexOf('image') == -1) {
        let message = this.errorInvalidMessage;
        let title = this.errorTitle;
        let okText = this.errorOkText;
        let cancelText = this.errorCancel;


        this.alertService
          .activate(message, title, okText, cancelText)
          .then((response) => { });
      } else {
        this.isThumb = true;
        this.addFile(fileList[0], mediaName);
        event.target.value = '';
      }
    }
  }

  onThumbnailGenerated(videoFrame) {
    let fileToSend = {
      entityId: this.entity.id,
      entityType: this.entity.type,
      media: {
        contentType: videoFrame.contentType,
        fileName: videoFrame.fileName.split(" ").join("_")
      }
    };

    let file = this.dataURItoBlob(videoFrame.image);

    this.uploadFileService
      .makeFileRequest(file, fileToSend, false)
      .subscribe((response) => {
        this.medias.forEach((media) => {
          if (media.fileName === videoFrame.videoFileName) {
            media.isNew = false;
          }
        });
      },
        (error) => {
          let message = this.errorMessage;
          let title = this.errorTitle;
          let okText = this.errorOkText;
          let cancelText = this.errorCancel;

          this.alertService
            .activate(message, title, okText, cancelText)
            .then((response) => { });
        },
        () => {
          this.updatedMedia.emit(this.medias);
          this.isUploading = false;

          // updating video tag (poster attr) after video upload
          let arrayName = videoFrame.fileName.split('-thumbnail');
          document.getElementById(arrayName[0] + '.mp4').setAttribute("poster", this.mediaUrl + videoFrame.fileName);
        });
  }

  getFrameName(name: string): string {
    let arrayName = name.split('.');

    return arrayName[0] + '-thumbnail.jpeg';
  }

  getVideoPoster(mediaFileName: string, mediaIsNew: boolean) {
    if (mediaIsNew != true)
      document.getElementById(mediaFileName).setAttribute("poster", this.mediaUrl + this.getFrameName(mediaFileName));
  }

  private dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
    }
    else {
      byteString = encodeURI(dataURI.split(',')[1]);
    }

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  private isInvalidMedia(media: any) {
    return (media.type.indexOf('image') >= 0 && media.size >= 2097152)
      || ((media.type.indexOf('video') >= 0 || this.entity.type == 'pushAttachmentMedia') && media.size >= 15728640)
      || (
        (this.entity.type == 'vehicle_main_photo'
          || this.entity.type == 'loginImage'
          || this.entity.type == 'acessoryMainPhoto'
          || this.entity.type == 'vehicle_external_photo'
          || this.entity.type == 'vehicle_internal_photo'
          || this.entity.type == 'vehicle_news'
          || this.entity.type == 'colors'
          || this.entity.type == 'compare_image'
          || this.entity.type == 'pushNewsMedia')
        && !(media.type.indexOf('image') >= 0)
      )

      || (
        (
          this.entity.type == 'pushAttachmentMedia' ||
          this.entity.type == 'pdf_diagram' ||
          this.entity.type == 'pdf_folder'
        ) &&
        !(media.type.indexOf('pdf') >= 0)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form-media/form-media.component.ts